(() => {
    document.addEventListener('DOMContentLoaded', function () {
        const scrollVelocityTime = document.querySelector('input[data-carousel-splide-velocity]');

        if (document.querySelector('.splide-collection')) {
            const splideCollection = document.querySelector('.splide-collection');
            const dataProductPerRowDesktop = splideCollection ? splideCollection.getAttribute('data-product-per-row-desktop') : null;
            const dataCarouselVelocity = splideCollection ? splideCollection.getAttribute('data-carousel-velocity') : null;
            const dataCarouselSplideVelocity = splideCollection ? splideCollection.getAttribute('data-carousel-splide-velocity') : null;
            const dataCarouselAutoplayMobile = splideCollection ? splideCollection.getAttribute('data-carousel-autoplay-mobile') : null;
            const dataCarouselAutoplayDesktop = splideCollection ? splideCollection.getAttribute('data-carousel-autoplay-desktop') : null;
            const dataCarouselTotalCollection = splideCollection ? splideCollection.getAttribute('data-total-collection') : null;

            const enableAutoScroll = splideCollection ? splideCollection.getAttribute('data-enable-autoscroll-desktop') === 'true' : false;
            const isAutoplayEnabled = dataCarouselAutoplayDesktop === 'true';
            const isAutoScrollActive = String(enableAutoScroll) === 'true';

            const splide = new Splide('.splide-collection', {
                type: isAutoplayEnabled || isAutoScrollActive ? 'loop' : 'slide',
                autoplay: isAutoScrollActive ? false : isAutoplayEnabled,
                snap: true,
                perPage: dataProductPerRowDesktop ? parseInt(dataProductPerRowDesktop) : 5,
                speed: 500,
                autoScroll: isAutoScrollActive ? {
                    speed: 1,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                } : false,
                gap: '15px',
                arrows: false,
                pagination: true,
                breakpoints: {
                    3500: {
                        perPage: dataProductPerRowDesktop ? parseInt(dataProductPerRowDesktop) : 5,
                        autoScroll: dataCarouselAutoplayDesktop === 'true' ? { speed: 1 } : false,
                        perMove: 3,
                        rewind: true
                    },
                    767: {
                        perPage: 3,
                        perMove: 3,
                        autoScroll: dataCarouselAutoplayMobile === 'true' ? { speed: 1 } : false,
                        rewind: true
                    },
                    480: {
                        perPage: 2,
                        perMove: 2
                    }
                }
            });
            splide.mount(window.splide.Extensions);
        }

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const splideRecently = document.querySelector('.splide-recently');
                    const dataProductPerRowDesktop = splideRecently ? splideRecently.getAttribute('data-product-per-row-desktop') : null;
                    const dataCarouselVelocity = splideRecently ? splideRecently.getAttribute('data-carousel-velocity') : null;
                    const dataCarouselSplideVelocity = splideRecently ? splideRecently.getAttribute('data-carousel-splide-velocity') : null;
                    const dataCarouselAutoplayMobile = splideRecently ? splideRecently.getAttribute('data-carousel-autoplay-mobile') : null;
                    const dataCarouselAutoplayDesktop = splideRecently ? splideRecently.getAttribute('data-carousel-autoplay-desktop') : null;
                    const dataCarouselTotalRecommendations = splideRecently ? splideRecently.getAttribute('data-total-recommendations') : null;

                    const enableAutoScroll = splideRecently ? splideRecently.getAttribute('data-enable-autoscroll-desktop') === 'true' : false;
                    const isAutoplayEnabled = dataCarouselAutoplayDesktop === 'true';
                    const isAutoScrollActive = String(enableAutoScroll) === 'true';

                    if (splideRecently) {
                        const splideRecentlyProduct = new Splide('.splide-recently', {
                            type: isAutoplayEnabled || isAutoScrollActive ? 'loop' : 'slide',

                            autoplay: isAutoScrollActive ? false : isAutoplayEnabled,

                            drag: 'free',
                            snap: true,
                            perPage: dataProductPerRowDesktop ? parseInt(dataProductPerRowDesktop) : 5,
                            arrows: false,
                            pagination: true,
                            gap: '15px',
                            autoScroll: isAutoScrollActive ? {
                                speed: 1,
                                pauseOnHover: true,
                                pauseOnFocus: true,
                            } : false,

                            breakpoints: {
                                3500: {
                                    perPage: parseInt(dataCarouselTotalRecommendations) === 1 ? 1 : 5,
                                    autoScroll: dataCarouselAutoplayDesktop === 'true' ? { speed: 1 } : false,
                                    perMove: 3,
                                    rewind: true
                                },
                                767: {
                                    perPage: parseInt(dataCarouselTotalRecommendations) === 1 ? 1 : 2,
                                    autoScroll: dataCarouselAutoplayMobile === 'true' ? { speed: 1 } : false,
                                    rewind: true
                                },
                                480: {
                                    perPage: 1,
                                }
                            }
                        });
                        splideRecentlyProduct.mount(window.splide.Extensions);

                        observer.disconnect();
                        break;
                    }
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
        
        const observerRecommended = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const splideRecommended = document.querySelector('.splide-recommended');
                    const dataProductPerRowDesktop = splideRecommended ? splideRecommended.getAttribute('data-product-per-row-desktop') : null;
                    const dataCarouselVelocity = splideRecommended ? splideRecommended.getAttribute('data-carousel-velocity') : null;
                    const dataCarouselSplideVelocity = splideRecommended ? splideRecommended.getAttribute('data-carousel-splide-velocity') : null;
                    const dataCarouselAutoplayMobile = splideRecommended ? splideRecommended.getAttribute('data-carousel-autoplay-mobile') : null;
                    const dataCarouselAutoplayDesktop = splideRecommended ? splideRecommended.getAttribute('data-carousel-autoplay-desktop') : null;
                    const dataCarouselTotalRecommendations = splideRecommended ? splideRecommended.getAttribute('data-total-recommendations') : null;

                    let enableAutoScroll = null;
                    let isAutoplayEnabled = null;
                    let isAutoScrollActive = null;
                    
                    if(splideRecommended) {
                        enableAutoScroll = splideRecommended.getAttribute('data-enable-autoscroll-desktop') === 'true';
                        isAutoplayEnabled = dataCarouselAutoplayDesktop === 'true';
                        isAutoScrollActive = String(enableAutoScroll) === 'true';
                    }

                    if (splideRecommended) {
                        const enableAutoScroll = dataCarouselAutoplayDesktop;
                        const splideRecommendedProduct = new Splide('.splide-recommended', {
                            type: isAutoplayEnabled || isAutoScrollActive ? 'loop' : 'slide',

                            autoplay: isAutoScrollActive ? false : isAutoplayEnabled,

                            drag: 'free',
                            snap: true,
                            perPage: dataProductPerRowDesktop ? parseInt(dataProductPerRowDesktop) : 5,
                            arrows: false,
                            pagination: true,
                            gap: '15px',
                            autoScroll: isAutoScrollActive ? {
                                speed: 1,
                                pauseOnHover: true,
                                pauseOnFocus: true,
                            } : false,

                            breakpoints: {
                                3500: {
                                    perPage: parseInt(dataCarouselTotalRecommendations) === 1 ? 1 : 5,
                                    autoScroll: dataCarouselAutoplayDesktop === 'true' ? { speed: 1 } : false,
                                    perMove: 3,
                                    rewind: true
                                },
                                767: {
                                    perPage: parseInt(dataCarouselTotalRecommendations) === 1 ? 1 : 2,
                                    autoScroll: dataCarouselAutoplayMobile === 'true' ? { speed: 1 } : false,
                                    rewind: true
                                },
                                480: {
                                    perPage: 1,
                                    rewind: true
                                }
                            }
                        });
                        
                        splideRecommendedProduct.mount(window.splide.Extensions);

                        observerRecommended.disconnect();
                        break;
                    }
                }
            }
        });

        observerRecommended.observe(document.body, { childList: true, subtree: true });
    });
})();